export default __webpack_public_path__ + "static/media/bg5.b93ec2db.png";